export default __webpack_public_path__ + "static/media/Maahum.45165202.jpg";